// NOT Redux middleware. These are singleton per-page lifecycle helpers,
// invoked from AbstractComponent.componentWillMount. `applyComponent(this)`
// hands the helper a live page reference, so `process()` can both dispatch
// and call `setState` on the page. State set this way lives on the page,
// not on the helper.
abstract class Middleware {
  public abstract component: any;

  public applyComponent(component: any): Middleware {
    this.component = component;
    return this;
  }
}

export { Middleware };
